var exports = {
  "qr": "footer__yuGqAl",
  "TR": "metadataBar__DUTSOf",
  "F9": "embedded__CpKMYq",
  "o1": "actions__FNie_l",
  "yu": "metadata__zZhr78",
  "HZ": "inlineMetadata__lnSlzV",
  "me": "separator__9U5cDy",
};

module.exports = exports;
